import { LoginForm } from '@/features/auth';

export default function SignInPage() {
  return <LoginForm />;
}
